import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import HomePage from './pages/NewHomePage';
import TermsPage from './pages/NewTermsPage';
import PrivacyPage from './pages/NewPrivacyPage';
import LegalPage from './pages/NewLegalPage';
import CookiesPage from './pages/NewCookiesPage';
import RefundPolicyPage from './pages/NewRefundPolicyPage';
import DeleteAccountPage from './pages/NewDeleteAccountPage';

/**
 * Scroll progress indicator — thin accent bar at top.
 */
function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };

    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 h-[2px] z-[9999] transition-[width] duration-100 ease-out"
      style={{
        width: `${progress}%`,
        background: 'linear-gradient(90deg, #0A174E, #FDBE34)',
        boxShadow: '0 0 8px rgba(253, 190, 52, 0.4)',
      }}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Scroll progress"
    />
  );
}

/**
 * Root App component.
 * Dark-first design, no theme toggle needed — the brand IS dark mode.
 */
export default function App() {
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-linx-bg text-linx_text-primary overflow-x-hidden">
          <ScrollProgress />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}
